import React, { Component } from "react";
import CountDown from "../CountDown";
import "./style.less";
import utils from "../../../../utils/utils";

class PrizesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
    };
  }

  componentDidMount() {
    const app_version = utils.getVersion();
    if (typeof window !== 'undefined' && app_version && utils.SHDiffVersion(app_version, '6.71.0')) {
      window.Jockey.send("uploadExposures", {
        list: [`${this.props.unique_id}.bz..topic_page_game_sale.pull_down_coupon.......`]
      }, () => {}); 
    }
  }

  handleGetPrizes() {
    if (typeof window !== 'undefined') {
      window.__dace.sendEvent('draw_gift', {
        from: "topic_page_game_sale",
        block: "pull_down_coupon",
      }); 
    }
    const { isLogin } = this.props;
    const { prize_type, jump_url } = this.props.info;
    switch (prize_type) {
      case 2: 
        window.Jockey.send("action", {
          url: jump_url
        });
        break;
      case 4:
        // 生活服务券
        if (!isLogin) {
          this.props.login();
          return;
        }
        window.Jockey.send("action", {
          url: jump_url
        });
        break;
      case 5:
        // 返现券
        window.Jockey.send("action", {
          url: jump_url
        });
        break;
      default:
        break;
    }
  }

  render() {
    const { prizesConfig } = this.props.config;
    const { info } = this.props;
    const { prize_pic, end_time } = info;

    const baseStyle = {
      backgroundImage: `url(${utils.formatImgUrl(prizesConfig.backgroundImage, this.props.webpSupport)})`,
      backgroundSize: "100% 100%"
    }
    return (
      <div className="games-prizes-wrap" style={baseStyle} onClick={() => this.handleGetPrizes()}>
        <img src={prizesConfig.maskImage} alt="" className="mask-image" />
        <ul>
          {
            prize_pic && prize_pic.length > 1 && prize_pic.map((item, index) => {
              if (index >= 1) {
                return (
                  <li key={index}>
                    <img src={item} alt="" />
                  </li>
                ) 
              } else {
                return null;
              }
            })
          }
        </ul>
        {end_time && (
          <div className={end_time * 1000 < new Date().getTime() ? 'count-down-end' : 'count-down'}>
            <CountDown end_time={end_time} />
          </div>
        )}
      </div>
    )
  }
}

export default PrizesList;



// WEBPACK FOOTER //
// ./components/pipeline-games/components/PrizesList/index.js